import React, { useState, useRef, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import axiosInstance from "../../../utils/AxiosInstance";
import useShowAlert from "../../../utils/AlertUtiles";
import handleError from "../../../constant/handleError";
import { useEscapeKeyContext } from "../../../contexts/UseEscapKeyContext";
const PaymentSettings = () => {
  const [errors, setErrors] = useState(false);
  const [newRow, setNewRow] = useState({
    tokenAmount: "",
    amountPerAcre: "",
    minimumAdvanceDays: "",
  });
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false); 
  const [savedRow, setSavedRow] = useState(null);
  const [loading, setLoading] = useState({
    add: false,
    list: false,
  });
  const { useEscapeKey } = useEscapeKeyContext();
  const tokenRef = useRef(null);
  const priceRef = useRef(null);
  const minDayRef = useRef(null);
  const saveButtonRef = useRef(null);

  const showAlert = useShowAlert();

  const validateRow = (row) => {
    const errors = {};
    if (!row.tokenAmount) {
      errors.tokenAmount = "Amount cannot be empty.";
    } else if (!row.amountPerAcre) {
      errors.price = "Price cannot be empty.";
    } else if (isNaN(Number(row.amountPerAcre))) {
      errors.price = "Price must be a valid number.";
    } else if (!row.minimumAdvanceDays) {
      errors.minimumAdvanceDays = "Day cannot be empty.";
    }
    return errors;
  };

  const handleAddRow = async (e) => {
    e.preventDefault();
    const validationErrors = validateRow(newRow);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      if (validationErrors.tokenAmount) tokenRef.current?.focus();
      else if (validationErrors.price) priceRef.current?.focus();
      else if (validationErrors.minimumAdvanceDays) minDayRef.current?.focus();
      return;
    }
    if (
      !newRow.tokenAmount ||
      !newRow.amountPerAcre ||
      !newRow.minimumAdvanceDays
    )
      return;
    setLoading((prev) => ({ ...prev, add: true }));
    try {
      const data = {
        tokenAmount: Number(newRow.tokenAmount),
        amountPerAcre: Number(newRow.amountPerAcre),
        minimumAdvanceDays: Number(newRow.minimumAdvanceDays),
      };
      const response = await axiosInstance.post(
        `transplantationsettings/admin/add`,
        data
      );
      const savedData = response?.data?.results?.paymentSettings?.[0];
      if (savedData) {
        const normalized = {
          tokenAmount: String(savedData.tokenAmount),
          amountPerAcre: String(savedData.amountPerAcre),
          minimumAdvanceDays: String(savedData.minimumAdvanceDays),
        };

        setNewRow(normalized);
        setSavedRow(normalized);
      }
      showAlert("success", response?.data?.message);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setLoading((prev) => ({ ...prev, add: false }));
    }
  };

  const handleEnterKey = (e, nextRef = null) => {
    if (e.key === "Enter") {
      e.preventDefault();

      if (nextRef && nextRef.current) {
        nextRef.current.focus();
      } else if (e.currentTarget === priceRef.current) {
        minDayRef.current?.click();
      } else if (e.currentTarget === minDayRef.current) {
        saveButtonRef.current?.click();
      }
    }
  };
  const handleEscapeKeyPress = () => {
    if (isDeleteDialogOpen) {
      setIsDeleteDialogOpen(false);
    }
  };
  useEscapeKey(handleEscapeKeyPress); 
  useEffect(() => {
    setTimeout(() => tokenRef.current.focus(), 200);
  }, []);
  const isDataChanged = () => {
    if (!savedRow) return true;

    return (
      String(newRow.tokenAmount) !== savedRow.tokenAmount ||
      String(newRow.amountPerAcre) !== savedRow.amountPerAcre ||
      String(newRow.minimumAdvanceDays) !== savedRow.minimumAdvanceDays
    );
  };

 const handleViewSetting = async () => {  
    setLoading((prev) => ({ ...prev, view: true }));
    try {
    
      const response = await axiosInstance.get(
        `transplantationsettings/view/`
      );
        const savedData = response?.data?.results?.paymentSettings;
      if (savedData) {
        const normalized = {
          tokenAmount: String(savedData.tokenAmount),
          amountPerAcre: String(savedData.amountPerAcre),
          minimumAdvanceDays: String(savedData.minimumAdvanceDays),
        };

        setNewRow(normalized);
        setSavedRow(normalized);
      }
         
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setLoading((prev) => ({ ...prev, view: false }));
    }
  };
   useEffect(() => {
      handleViewSetting();
    }, []);
  return (
    <>
      <div className="card mb-0  ">
        <div class="card-header p-3 bg-light-theme">
          <h6 class="mb-0 text-dark">Add Payment Settings</h6>
        </div>
        <div className="card-body p-3">
          <div className="row g-3">
            <div className="col-lg-4 col-md-4">
              <label className="form-label">
                Token Amount <span className="text-danger">*</span>
              </label>

              <input
                type="text"
                ref={tokenRef}
                className="form-control me-2"
                autoComplete="off"
                placeholder=""
                value={newRow.tokenAmount}
                onChange={(e) => {
                  setErrors("");
                  const val = e.target.value.replace(/\D/g, "");
                  setNewRow((s) => ({
                    ...s,
                    tokenAmount:val,
                  }));
                }}
                onKeyDown={(e) => handleEnterKey(e, priceRef)}
              />
              {errors.tokenAmount && (
                <div className="error-message invalid-feedback">
                  {errors.tokenAmount}
                </div>
              )}
            </div>
            <div className="col-lg-4 col-md-4">
              <label className="form-label">
                Amount Per Acre
                <span className="text-danger">*</span>
              </label>

              <input
                type="text"
                ref={priceRef}
                className="form-control"
                autoComplete="off"
                placeholder=""
                value={newRow.amountPerAcre}
                onChange={(e) => {
                  setErrors("");
                  const val = e.target.value.replace(/\D/g, "");
                  setNewRow((s) => ({
                    ...s,
                    amountPerAcre: val,
                  }));
                }}
                onKeyDown={(e) => handleEnterKey(e, minDayRef)}
              />
              {errors.price && (
                <div className="error-message invalid-feedback">
                  {errors.price}
                </div>
              )}
            </div>

            <div className="col-lg-4 col-md-4">
              <label className="form-label">
                Minimum Advance Days <span className="text-danger">*</span>
              </label>
              <input
                type="number"
                className="form-control"
                value={newRow.minimumAdvanceDays}
                ref={minDayRef}
                onChange={(e) => {
                  setErrors("");
                const val = e.target.value.replace(/\D/g, "");
                setNewRow((s) => ({ ...s, minimumAdvanceDays: val }));
              }}
                onKeyDown={(e) => handleEnterKey(e, saveButtonRef)}
              />
              {errors.minimumAdvanceDays && (
                <div className="error-message invalid-feedback">
                  {errors.minimumAdvanceDays}
                </div>
              )}
            </div>
          </div>
          <div className="mt-2  d-flex justify-content-end">
            {loading.add ? (
              <button className="btn btn-primary pb-0 text-right" disabled>
                <CircularProgress size={22} className="text-white" />
              </button>
            ) : (
              <button
                type="submit"
                ref={saveButtonRef}
                className="btn btn-primary text-right "
                disabled={
                  !newRow.tokenAmount ||
                  !newRow.amountPerAcre ||
                  !newRow.minimumAdvanceDays ||
                  !isDataChanged()
                }
                onClick={handleAddRow}
              >
                <i className="bx bx-check me-1" />
                Save
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentSettings;
